export default "__VITE_ASSET__dMtd1RZc__"